
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { ActualPowerCountryGQL, ActualPowerPortfolioGQL, ActualPowerParkGQL, ActualPowerTurbineGQL } from '../../graphql';
import { distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { ForecastGraph } from 'app/models/forecast/forecast-graph.model';

@Injectable()
export class ForecastGraphService {

    constructor(
        private actualPowerCountry: ActualPowerCountryGQL,
        private actualPowerPortfolio: ActualPowerPortfolioGQL,
        private actualPowerPark: ActualPowerParkGQL,
        private actualPowerTurbine: ActualPowerTurbineGQL) { }


    public getActualPowerPark(parkNameObservable: Observable<string>): Observable<any> {
        return parkNameObservable.pipe(
            distinctUntilChanged(),
            switchMap((parkName: string) =>
                this.actualPowerPark.subscribe({ 
                    variables: {
                        name: parkName }
                    }).pipe(map(result => ForecastGraph.mapDataMW(result.data.parks[0])))
            )
        );
    }
    public getActualPowerCountry(countryNameObservable: Observable<string>): Observable<any> {
        return countryNameObservable.pipe(
            distinctUntilChanged(),
            switchMap((countryName: string) =>
                this.actualPowerCountry.subscribe({
                    variables: {
                        name: countryName}
                    }).pipe(map(result => ForecastGraph.mapDataMW(result.data.countries[0])))
            )
        );
    }
    public getActualPowerPortfolio(): Observable<any> {
        return this.actualPowerPortfolio.subscribe().pipe(map(result => ForecastGraph.mapDataMW(result.data.portfolios[0])));
    }

    public getActualPowerTurbine(turbineSerialObservable: Observable<number>): Observable<any> {
        return turbineSerialObservable.pipe(
            distinctUntilChanged(),
            switchMap((turbineSerial: number) =>
                this.actualPowerTurbine.subscribe({
                    variables: {
                        serialNav: turbineSerial
                    }
                }).pipe(map(result => ForecastGraph.mapDataMW(result.data.turbines[0])))
            )
        );
    }

    getMonitoringData(level, name) {

        let subscription;
        switch (level) {
          case 'portfolio':
            subscription = this.getActualPowerPortfolio();
            break;
          case 'country':
            subscription = this.getActualPowerCountry(name);
            break;
          case 'park':
            subscription = this.getActualPowerPark(name);
            break;
          case 'turbine':
            subscription = this.getActualPowerTurbine(name);
            break;
        }
        return subscription;
      }
}
